export default (state, action) => {
    switch (action.type) {
        case 'SET_SHIPMENT':
            return {
                ...state,
                embarqueSummary: [...state.embarqueSummary, action.payload]
            };
        case 'SET_RESULTS':
            return {
                ...state,
                results: action.payload
            };
        case 'SET_RESULTS_LIST':
            return {
                ...state,
                resultList: action.payload
            };
        case 'SET_SEARCH_VALUE':
            return {
                ...state,
                filterSearch: action.payload
            };
        case 'SET_EVENT_LIST':
            return {
                ...state,
                eventList: action.payload
            };
        case 'SET_DOWNLOAD_ESTATUS':
            return {
                ...state,
                openReserva: action.payload,
                openOrigen: action.payload,
                openDestino: action.payload,
            };
        default: return state;
    }
}